import React, { useState } from "react";
import gymimage from "../../images/apple.png";
import { Services } from "../../api/Services";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

// code add By Zohaib

const FormComponent = ({
  handleCloseForm,
  listName,
  setListName,
  selectedusers,
  userinput,
  setUsers,
  handleSubmit,
  handleuserinputChange,
  removeUser,
  toggleItem,
  editStat,
  users,
  formLoading,
  searchPaging,
  setSearchPaging,
}) => {
  const [page, setPage] = useState(1);
  const [haseMoreDate, setHasMoredata] = useState(true);

  const loadMore = async () => {
    try {
      if (page + 1 < searchPaging.total_pages + 1) {
        const result = await Services.getProgrammUsers(userinput, page + 1);
        if (result.status === 200) {
          setUsers([...users, ...result?.data?.data?.listing]);
          setPage(page + 1);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        setHasMoredata(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // waiting Loader
  const loader = () => {
    return (
      <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
      </div>
    );
  };

  return (
    <div className="excercise-modal trainings-modal mt-4 pt-4">
      <i className="fa fa-times" onClick={handleCloseForm}></i>
      <p className="title-small">{editStat ? `Edit List` : `Add new List`}</p>
      <div className="child-modal ">
        <div className="cont">
          <div className="form-group relative">
            <label htmlFor="id167">List Name</label>
            <input
              id="id167"
              type="text"
              className="input"
              value={listName}
              onChange={(e) => setListName(e.target.value)}
            />
            <div className="form-selected-users">
              {Array.isArray(selectedusers) && selectedusers.length > 0 && (
                <ul>
                  {selectedusers.map((suser) => (
                    <li key={suser?.id}>
                      <div className="img">
                        <i
                          className="fa fa-times"
                          onClick={() => removeUser(suser)}
                        ></i>
                        {suser?.image ? (
                          <img
                            src={getImageUrl(suser?.image, BASE_URL_MEDIA)}
                          />
                        ) : (
                          <img src={gymimage} alt="imgae-girl" />
                        )}
                      </div>
                      <span className="name">{suser?.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <label htmlFor="">Search users</label>
            <input
              type="text"
              value={userinput}
              onChange={async (e) => {
                setPage(1);
                setHasMoredata(true);
                handleuserinputChange(e);
              }}
              placeholder="Search users"
              className="form-control input"
            />
            <div className="form-user-list">
              {Array.isArray(users) && users.length > 0 && (
                <i className="fa fa-times" onClick={() => setUsers([])}></i>
              )}
              {Array.isArray(users) && users.length > 0 && (
                <ul>
                  <InfiniteScroll
                    dataLength={users.length}
                    next={loadMore}
                    hasMore={haseMoreDate}
                    height={100}
                    scrollableTarget="form-user-list"
                  >
                    {users.map((user, index) => (
                      <li
                        key={user?.id}
                        className={
                          selectedusers.includes(user) ? "selected" : ""
                        }
                        onClick={() => toggleItem(user)}
                      >
                        <div className="img">
                          {user?.image ? (
                            <img
                              src={getImageUrl(user?.image, BASE_URL_MEDIA)}
                            />
                          ) : (
                            <img src={gymimage} />
                          )}
                        </div>
                        <span className="name">{user?.name}</span>
                      </li>
                    ))}
                  </InfiniteScroll>
                </ul>
              )}
            </div>
          </div>
        </div>
        {!formLoading ? (
          <div className="d-flex justify-content-between  form-button ">
            <button
              className={`button ${
                selectedusers !== null ? "button-style-form" : ""
              }`}
              onClick={() => handleSubmit()}
            >
              Save
            </button>{" "}
          </div>
        ) : (
          loader()
        )}
      </div>
    </div>
  );
};

export default FormComponent;
